// extracted by mini-css-extract-plugin
export default {"list":"list__bA9tp","badgeContainer":"badgeContainer__l8r42","badge":"badge__uSB+s","pill":"pill__CQyiw","highContrastPill":"highContrastPill__hVExV"};